import React from 'react';
import { CgMore } from 'react-icons/cg';
import { FaCalendar, FaCar, FaCheckCircle, FaTasks, FaUser, FaPlus } from 'react-icons/fa';
import { GiKeyCard } from 'react-icons/gi';
import Avatar from 'react-avatar';
import Price from 'components/common/Price';

interface Props {
    className?: string;

    longRunningRoHighlightColor?: string;
    longRunningRoHighlightStyle?: number;
    showROAgeHighlight?: boolean;
    ageDaysToShow?: number; // Optional prop to control the age days to show
}

const BoilerplateTicketCard: React.FC<Props> = ({
    className = '',
    longRunningRoHighlightColor = '',
    longRunningRoHighlightStyle = 0,
    showROAgeHighlight = false,
    ageDaysToShow = 0,
}) => {
    const toneDownColor = (hex: string, percent: number) => {
        // 1. Parse the hex string into R, G, B values
        let r = parseInt(hex.substring(1, 3), 16);
        let g = parseInt(hex.substring(3, 5), 16);
        let b = parseInt(hex.substring(5, 7), 16);

        // 2. Calculate the amount to increase each component
        const amount = percent / 100;
        r = Math.floor(r + (255 - r) * amount);
        g = Math.floor(g + (255 - g) * amount);
        b = Math.floor(b + (255 - b) * amount);

        // 3. Ensure values don't exceed 255
        r = r > 255 ? 255 : r;
        g = g > 255 ? 255 : g;
        b = b > 255 ? 255 : b;

        // 4. Convert the new R, G, B values back to a hex string
        const toHex = (c: number) => ('0' + c.toString(16)).slice(-2);
        return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

    return (
        <div
            className={`border rounded-lg mb-4 bg-white hover:bg-blue-50 ${className} ${
                showROAgeHighlight && longRunningRoHighlightStyle !== 1 ? 'border-l-4' : ''
            }`}
            style={{
                borderColor: showROAgeHighlight && longRunningRoHighlightStyle !== 1 ? longRunningRoHighlightColor : '',
            }}
        >
            <div
                className={`border-l-4 rounded-md py-2 px-2 ${
                    showROAgeHighlight && longRunningRoHighlightStyle !== 1 ? '' : 'border-green-600'
                } 
                m-0 p-0`}
                style={{
                    borderColor:
                        showROAgeHighlight && longRunningRoHighlightStyle !== 1 ? longRunningRoHighlightColor : '',
                    backgroundColor:
                        showROAgeHighlight && longRunningRoHighlightStyle !== 0
                            ? toneDownColor(longRunningRoHighlightColor, 66)
                            : '',
                }}
            >
                <div className="flex">
                    <div className="font-bold text-gray-500 text-sm">RO #1004</div>
                    <div className="ml-auto relative pl-6 clickable">
                        <CgMore size={15} className="clickable" />
                    </div>
                </div>
                <div className="flex">
                    <span className="font-semibold text-blue-500">Oil change and tire rotation</span>
                </div>
                {/* <div className="non-clickable mb-1">
                    <div className="items-baseline">
                        <span className="inline-flex mr-2">
                            <div className="p-1 border border-gray-300 rounded hover:bg-gray-50 cursor-pointer">
                                <FaPlus size={12} className="text-gray-500" />
                            </div>
                        </span>
                        <span
                            style={{ backgroundColor: '#DC2626' }}
                            className="mr-2 px-1 py-1 rounded-lg hover:opacity-80 text-xs"
                        >
                            <span className="font-semibold text-white inline-flex whitespace-nowrap">VIP</span>
                        </span>
                    </div>
                </div> */}
                <div className="flex">
                    <div>
                        <FaCar className="inline mr-2 align-baseline text-gray-500" />
                        <span>2018 Ford F-150 XLT</span>
                    </div>
                </div>
                <div>
                    <FaUser className="inline mr-2 align-baseline text-gray-500" />
                    <span>Brandon Miles</span>
                </div>
                {ageDaysToShow ? (
                    <div className="flex items-center">
                        <span className="text-xs text-red-500">
                            <span className="font-bold">{ageDaysToShow}</span> {ageDaysToShow === 1 ? 'day' : 'days'}{' '}
                            old
                        </span>
                    </div>
                ) : null}
                <div className="pt-2">
                    <div className="flex">
                        <div className="pr-2">
                            <Avatar name="Service Writer" round size={'22'} className="clickable" />
                        </div>
                        <div className="pr-2 py-2">
                            <FaCheckCircle className="text-green-500" />
                        </div>
                        <div className="pr-2 py-2">
                            <FaTasks className="text-gray-500" />
                        </div>
                        <div className="pr-2 py-2">
                            <FaCalendar className="text-gray-500" />
                        </div>
                        <div className="ml-auto font-bold align-bottom items-end self-end">
                            <Price price={38900} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BoilerplateTicketCard;
